/**
 * @generated SignedSource<<17eabe4e1fb9e4265007d291249ab1f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEvent_timelineItem$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly createdByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActorCompact_actor" | "SignedActor_actor">;
  } | null;
  readonly " $fragmentType": "TodoTimelineUpdateEvent_timelineItem";
};
export type TodoTimelineUpdateEvent_timelineItem$key = {
  readonly " $data"?: TodoTimelineUpdateEvent_timelineItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEvent_timelineItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEvent_timelineItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "createdByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActorCompact_actor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoTimelineUpdate",
  "abstractKey": null
};

(node as any).hash = "ed636bbd0f39356186a1c7a0243c0a52";

export default node;
